
import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Dropdown, Nav, Card, Table, Pagination } from 'react-bootstrap';
import { useCampaignSummaryMutation, useDnldCampaignSummaryMutation } from "Services/services";
import moment from "moment-timezone";
import { CalendarIcon, CheckIcon, CogIcon, DownloadIcon, SearchIcon, XCircleIcon } from "@heroicons/react/solid";
import Datetime from "react-datetime";
import hasPermission from "pages/Permissions";
import { downloadBlobFile } from "components/Utility";
import Select from "react-select";
// import { Link } from "react-router-dom";


export default () => {

  //usertype
  const userData = localStorage.getItem('TOKEN');
  const userObject = JSON.parse(userData);
  const userID = userObject.id;
  const userType = userObject.user_type;

  const [tableData, setTableData] = useState([]);

  // const [bulkOption, setBulkOption] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [status, setStatus] = useState(null);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState('');

  const channelFilterOptions = [
    { label: "SMS", value: "sms" },
    { label: "WhatsApp", value: "whatsapp" },
    { label: "RCS", value: "rcs" }
  ]


  const [campaignSummary] = useCampaignSummaryMutation();
  const [dnldCamp] = useDnldCampaignSummaryMutation();



  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 2000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await campaignSummary({
          page: currentPage,
          limit: pagelimit,
          campaign_name: searchValue,
          mode: status?.value,
          startDate: start ? start.format("YYYY-MM-DD") : "",
          endDate: end ? end.format("YYYY-MM-DD") : "",
        });

        if (response?.data?.statusCode === 200) {
          setTableData(response?.data?.data?.queryData || []);
          setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pagelimit));
          setTotalPosts(response?.data?.data?.totalRecords || 0);
        } else {
          setTableData([]);
          setTotalPages(0);
          setTotalPosts(0);
        }
      } catch (error) {
        alert(error.message);
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    };

    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pagelimit, status, debouncedValue, start, end]);


  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  const TableRow = (props) => {
    const variant = props.mode === "whatsapp" ? "success"
      : props.mode === "sms" ? "purple"
        : props.mode === "rcs" ? "warning" : "primary";
        
        const calcProcessingMessg = (props) => {
          // Convert values to numbers safely
          const total = Number(props.totalSubmitted) || 0;
          const success = Number(props.totalSuccess) || 0;
          const read = Number(props.totalRead) || 0;
          const failed = Number(props.totalFailure) || 0;
        
          // Ensure they are valid numbers before calculating
          if ([total, success, read, failed].some(isNaN)) {
            console.error("Invalid input: props contain non-numeric values");
            return 0; // or throw an error depending on your use case
          }
        
          const remaining = total - (success + read + failed);
          return remaining;
        };

    return (
      <tr className="border-bottom">
        <td><span title={props.campaign_name || "-"} className="fw-normal">{props.campaign_name || '-'}</span></td>
        {userType !== 'enterprise' && <td><span title={props.enterprise_name || "-"} className="fw-normal">{props.enterprise_name || '-'}</span></td>}
        <td><span title={props.mode || "-"} className={`text-capitalize text-${variant}`}>{props.mode || '-'}</span></td>
        <td><span title={moment(props.time).format('DD/MM/YYYY') || "-"} className="fw-normal">{moment(props.time).format('DD/MM/YYYY')}</span></td>
        <td><span title={props.totalSubmitted || "-"} className="fw-normal">{props.totalSubmitted || '-'}</span></td>
        <td><span title={props.totalSuccess || "-"} className="fw-normal">{props.totalSuccess || '-'}</span></td>
        <td><span title={props.totalRead || "-"} className="fw-normal">{props.totalRead || '-'}</span></td>
        <td><span title={props.totalFailure || "-"} className="fw-normal">{props.totalFailure || '-'}</span></td>
        <td><span title={props.totalInprocessing || "-"} className="fw-normal">{calcProcessingMessg(props)}</span></td>
      </tr>
    );
  };

  const canDownload = hasPermission("Campaign Analytics", "download");
  const handleDownload = async () => {
    try {
      const blob = await dnldCamp({
        campaign_name: searchValue,
        mode: status?.value,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
      }).unwrap();
      downloadBlobFile(blob, "Campaign_Analytics.csv");
    } catch (error) {
      if (error?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  }

  return (
    <Card border={1}>
      <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
        <InputGroup className="d-flex flex-nowrap fmxw-300">
          <InputGroup.Text>
            <SearchIcon className="icon icon-xs" />
          </InputGroup.Text>
          <Form.Control
            type="search"
            isClearable
            placeholder="Campaign Name"
            value={searchValue}
            onChange={changeSearchValue}
          />
        </InputGroup>
        {/* <Form.Select
          onChange={handleStatus}
          value={status}
          className="mb-3 fmxw-300"
          style={{
            borderRadius: "11px",
            borderColor: "#E2E8F0",
            backgroundColor: "#fff",
            color: "#1D1D1F",
            padding: "0.375rem 0.75rem", // Bootstrap input padding
            minHeight: "38px",
            boxShadow: "none",
            outline: "none",
          }}
          onFocus={(e) => (e.target.style.borderColor = "#CBD5E1")}
          onBlur={(e) => (e.target.style.borderColor = "#E2E8F0")}
        >
          <option value="" defaultValue>All Channel</option>
          <option value="sms">SMS</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="rcs">RCS</option>
        </Form.Select> */}
        <Select
          options={channelFilterOptions}
          placeholder="Select Channel"
          className="fix-200"
          classNamePrefix="react-select"
          value={status}
          isClearable
          onChange={(selectedOption) => {setStatus(selectedOption)}}
        />

<Form.Group id="DateRange">
                  <InputGroup className="d-flex flex-nowrap">
                    <InputGroup.Text
                      onClick={() => {
                        setStart(null);
                        setEnd(null);
                      }}
                    >
                      {start || end ? (
                        <XCircleIcon className="icon icon-xs" />
                      ) : (
                        <CalendarIcon className="icon icon-xs" />
                      )}
                    </InputGroup.Text>
                    <Datetime
                      timeFormat={false}
                      onChange={(date) => {
                        if (moment.isMoment(date)) {
                          setStart(date);
                        }
                      }}
                      closeOnSelect={true}
                      renderInput={(props, openCalendar) => (
                        <Form.Control
                          type="search"
                          placeholder="Start Date"
                          value={
                            start ? moment(start).format("DD/MM/YYYY") : ""
                          }
                          onFocus={openCalendar}
                          readOnly
                          style={{ width: "150px", borderRadius: "0" }}
                        />
                      )}
                    />
                    <Datetime
                      timeFormat={false}
                      onChange={(date) => {
                        if (moment.isMoment(date)) {
                          setEnd(date);
                        }
                      }}
                      closeOnSelect={true}
                      isValidDate={(currDate) => currDate.isAfter(start)}
                      initialViewDate={end}
                      renderInput={(props, openCalendar) => (
                        <Form.Control
                          type="search"
                          placeholder="End Date"
                          value={end ? moment(end).format("DD/MM/YYYY") : ""}
                          onFocus={openCalendar}
                          readOnly
                          style={{
                            width: "150px",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                          }}
                        />
                      )}
                    />
                  </InputGroup>
                </Form.Group>

        <div className="ms-auto d-flex gap-2">
          {canDownload && (
            <Button
              variant="outline-gray-300"
              className="p-2"
              onClick={handleDownload}
            >
              <DownloadIcon className="icon icon-sm" />
            </Button>
          )}

          <Dropdown className="">
            <Dropdown.Toggle split as={Button} variant="outline-gray-300" className="text-dark m-0 p-2">
              <CogIcon className="icon icon-sm" />
              <span className="visually-hidden">Toggle Dropdown</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
              <span className="small ps-2 fw-bold text-dark">Rows per page</span>
              {[10, 20, 30].map((limit) => (
                <Dropdown.Item
                  key={limit}
                  className={`d-flex align-items-center fw-bold ${limit === 30 ? 'rounded-bottom' : ''}`}
                  onClick={() => {
                    setPagelimit(limit); // Update the page limit
                    setCurrentPage(1);  // Reset the page number to 1
                  }}
                >
                  {limit} {pagelimit === limit && <CheckIcon className="icon icon-xxs ms-auto" />}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="custom-scroll-wrapper">
        <div className="scroll-container">
          <Table responsive className="align-items-center table-flush table-outlines">
            <thead className="thead-light">
              <tr>
                <th className="border-bottom">Campaign Name</th>
                {userType !== 'enterprise' && <th className="border-bottom">Enterprise Name</th>}
                <th className="border-bottom">Channel Name</th>
                <th className="border-bottom" style={{minWidth:'120px'}}>Date</th>
                <th className="border-bottom">Total Messages</th>
                <th className="border-bottom">Success</th>
                <th className="border-bottom">Read</th>
                <th className="border-bottom">Failed</th>
                <th className="border-bottom">In-Process</th>
              </tr>
            </thead>
            <tbody className="border-0">
              {tableData.length > 0 ? tableData.map((u, index) => (
                <TableRow key={index + 1} index={index + 1} {...u} />
              )) :
                <tr>
                  <td colSpan="8" className="text-center text-danger">No Data Found</td>
                </tr>}
            </tbody>
          </Table>
        </div>
      </div>

      <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
        <Nav>
          <Pagination className="mb-0">
            <Pagination.Prev onClick={handlePrev} disabled={currentPage === 1}>
              Previous
            </Pagination.Prev>
            {currentPage >= 3 && (
              <>
                <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                <Pagination.Ellipsis />
              </>
            )}
            {currentPage > 1 && (
              <Pagination.Item onClick={() => handlePageChange(currentPage - 1)}>
                {currentPage - 1}
              </Pagination.Item>
            )}
            <Pagination.Item active>{currentPage}</Pagination.Item>
            {currentPage < totalPages && (
              <Pagination.Item onClick={() => handlePageChange(currentPage + 1)}>
                {currentPage + 1}
              </Pagination.Item>
            )}
            {currentPage < totalPages - 1 && (
              <>
                <Pagination.Ellipsis />
                <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Pagination.Item>
              </>
            )}
            <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages}>
              Next
            </Pagination.Next>
          </Pagination>

        </Nav>
        <small className="fw-normal small mt-2 mt-md-0">
          Showing <b>{totalPosts === 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-{(pagelimit * currentPage) > totalPosts ? totalPosts : (pagelimit * currentPage)}</b> of <b>{totalPosts}</b>{" "}entries.
        </small>
      </Card.Footer>

    </Card>
  );
};



